import React from "react";
import ListItem from "@mui/material/ListItem";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { StyledCard, StyledBox } from "../BenevvPopup.styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box } from "@mui/material";

export interface Item {
  id: number;
  activity_title: string;
  start_date_time: string;
  end_date_time: string;
  places: [
    {
      place_postcode: string;
      place_city: string;
      place_state: string;
    }
  ];
  visuals: {
    activity_id: number;
    image_url: string;
  };
}

interface BenevvPopupEventProps {
  item: Item;
  selected: boolean;
  onClick: () => void;
}

const BenevvPopupEvent = ({
  item,
  selected,
  onClick,
}: BenevvPopupEventProps) => (
  <ListItem key={item.id} disablePadding>
    <StyledCard selected={selected} onClick={onClick}>
      <Avatar
        variant="rounded"
        src={item?.visuals?.image_url}
        sx={{ width: "90px", height: "90px" }}
      />
      <CardContent>
        <Typography sx={{ fontSize: "20px", marginBottom: 0.5 }}>
          {item.activity_title}
        </Typography>
        <Box display="flex" alignItems="center" color="#757575">
          <AccessTimeIcon fontSize="small" />
          <Typography sx={{ fontSize: "12px" }} marginLeft={0.5}>
            {" "}
            {new Date(item.start_date_time).toLocaleString()}{" "}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" color="#757575">
          <LocationOnIcon fontSize="small" />
          <Typography sx={{ fontSize: "12px" }} marginLeft={0.5}>
            {item.places[0].place_city ? `${item.places[0].place_city}, ` : ""}
            {item.places[0].place_state ?? ""}
          </Typography>
        </Box>
      </CardContent>
      <StyledBox selected={selected} />
    </StyledCard>
  </ListItem>
);

export default BenevvPopupEvent;
